import { initializeButtonEffect } from './functions.js';

function customforms_checkbox() {
	const checkboxes = document.querySelectorAll('input[type="checkbox"]');
	checkboxes.forEach((checkbox) => {
		const label = document.createElement('label');
		checkbox.parentNode.insertBefore(label, checkbox.nextSibling);
	});
}
customforms_checkbox();

function dropDownImage(image, el) {
	const optionImageURL = image.getAttribute('data-image');
	if (optionImageURL) {
		// console.log(optionImageURL);
		// Create <img> element for the image
		const optionImage = document.createElement('img');
		optionImage.src = optionImageURL;
		optionImage.alt = image.textContent; // Set alt text to option text
		el.appendChild(optionImage);
		// console.log(optionImageURL);
	}
}

function customforms_select() {
	// console.log('forms');

	// if (!isMobile()) {
	const selects = document.querySelectorAll('select');
	selects.forEach((select) => {
		// add class to the select
		select.classList.add('dropdown-select');

		// create custom dropdown wrapper
		const dropdownParent = document.createElement('div');
		// dropdownParent.className = 'custom-dropdown ' + select.className;
		dropdownParent.className = 'custom-dropdown ';

		// get data from select field
		const options = select.querySelectorAll('option');

		// custom dropdown text
		const customDropdownText = document.createElement('div');
		customDropdownText.className = 'custom-dropdown-text';
		dropdownParent.appendChild(customDropdownText);
		customDropdownText.textContent = options[0].textContent;

		// Set the selected value in the new custom dropdown
		const selectedOption = select.querySelector('option:checked');
		if (selectedOption) {
			customDropdownText.textContent = selectedOption.textContent;
		}

		// wrap the select inside a custom dropdown
		// select.parentNode.insertBefore(dropdownParent, select);
		// dropdownParent.appendChild(select);
		select.insertAdjacentElement('afterend', dropdownParent);

		// custom dropdown
		const dropdown = document.createElement('ul');
		dropdown.className = 'dropdown';
		dropdownParent.append(dropdown);

		// custom dropdown arrow
		const customArrow = document.createElement('div');
		customArrow.className = 'custom-arrow';
		customArrow.innerHTML =
			'<svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.5L6 6.5L11 1.5" stroke="#8A7C73" stroke-width="2" stroke-linecap="round" vector-effect="non-scaling-stroke"/></svg>';
		dropdownParent.appendChild(customArrow);

		options.forEach((option, index) => {
			// create <li> list
			const listItem = document.createElement('li');
			dropdown.appendChild(listItem);

			// set values of each item list from <option>
			listItem.textContent = option.textContent;
			listItem.setAttribute('data-value', option.value);

			// Add image to custom dropdown <li>, data url grabbed from data-image=""
			dropDownImage(option, listItem);

			listItem.addEventListener('click', () => {
				const value = listItem.getAttribute('data-value');
				customDropdownText.textContent = listItem.textContent; // change custom-dropdown-text value

				// Update the selected option value of the associated <select>
				select.value = value;

				dispatchChangeEvent(select);

				// add selected class to parent when clicking listitem but the first placeholder
				if (index > 0) {
					dropdownParent.classList.add('selected');
				} else {
					dropdownParent.classList.remove('selected');
				}
			});
		});

		dropdownParent.addEventListener('click', () => {
			dropdownParent.classList.toggle('active');
		});
	});
	// }
}

// Function to remove existing custom dropdowns
function removeCustomDropdowns() {
	const customDropdowns = document.querySelectorAll('.custom-dropdown');
	customDropdowns.forEach((customDropdown) => {
		customDropdown.parentNode.removeChild(customDropdown);
	});
}

// Function to handle FacetWP-loaded and FacetWP-refresh events
function handleFacetWPEvents() {
	removeCustomDropdowns(); // Remove existing custom dropdowns
	customforms_select(); // Reinitialize custom select
}

// Alternative function to dispatch a change event
function dispatchChangeEvent(element) {
	const event = document.createEvent('Event');
	event.initEvent('change', true, true);
	element.dispatchEvent(event);
}

customforms_select();
document.addEventListener('facetwp-loaded', handleFacetWPEvents);
document.addEventListener('facetwp-refresh', handleFacetWPEvents);
document.addEventListener('load', () => {
	// customforms_select();
});

// Global click event listener to close dropdowns when clicking outside
document.addEventListener('click', (event) => {
	const dropdowns = document.querySelectorAll('.custom-dropdown');
	dropdowns.forEach((dropdown) => {
		if (!dropdown.contains(event.target)) {
			dropdown.classList.remove('active');
		}
	});
});

function customforms_radio() {
    const radioGroups = {};

    // Group radio buttons by their name attribute
    document.querySelectorAll('input[type="radio"]').forEach((radio) => {
        const name = radio.getAttribute('name');
        if (!radioGroups[name]) {
            radioGroups[name] = [];
        }
        radioGroups[name].push(radio);
    });

    // Process each group of radio buttons
    Object.values(radioGroups).forEach((radioGroup) => {
        let anyChecked = false;

        // Check if any radio in the group is already selected
        radioGroup.forEach((radio) => {
            if (radio.checked) {
                anyChecked = true;
            }
        });

        // // If none are checked, check the first radio in the group
        // if (!anyChecked && radioGroup.length > 0) {
        //     radioGroup[0].checked = true;
        // }

        // Add custom styling and event listeners
        radioGroup.forEach((radio) => {
            // Ensure the radio is wrapped in a <label>
            let label = radio.closest('label');
            if (!label) {
                label = document.createElement('label');
                radio.parentNode.insertBefore(label, radio);
                label.appendChild(radio);
            }
            label.classList.add('custom-radio-group');

            // Check if the radio is already wrapped in a <span>
            let wrapper = radio.parentNode.querySelector('.custom-radio');
            if (!wrapper) {
                wrapper = document.createElement('span');
                wrapper.className = 'custom-radio';
                radio.parentNode.insertBefore(wrapper, radio);
                wrapper.appendChild(radio);
            }

            // Add a span for the custom radio styling
            if (!wrapper.querySelector('span')) {
                const innerSpan = document.createElement('span');
                innerSpan.className = 'custom-radio-icon';
                // innerSpan.innerHTML = '<svg width="26" height="18" viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg" non-scaling-stroke><path d="M1.5 8L9.5 16L24.5 1" stroke="#EA2026" stroke-width="2"/></svg>';
                wrapper.appendChild(innerSpan);
            }

            // Check if a span exists after .custom-radio and use it
            let labelSpan = label.querySelector(':scope > span:not(.custom-radio)');
            if (!labelSpan) {
                labelSpan = document.createElement('span');
                labelSpan.className = 'custom-radio-icon';
                label.appendChild(labelSpan);
            }
            labelSpan.className = 'custom-radio-text';
            labelSpan.textContent = radio.getAttribute('data-label') || radio.value;

            // Set active class if the radio is checked
            if (radio.checked) {
                label.classList.add('selected');
            }

            // Update on change
            radio.addEventListener('change', () => {
                // Deselect all other radios in the same group
                radioGroup.forEach((input) => {
                    const inputLabel = input.closest('label');
                    if (inputLabel) {
                        inputLabel.classList.remove('selected');
                    }
                });

                // Add active class to the current radio
                label.classList.add('selected');
            });
        });
    });
}

// Initialize the function
customforms_radio();

function handleFileChange() {
	const customFileInputs = document.querySelectorAll(
		'.custom-file-input-wrapper'
	);

	customFileInputs.forEach((wrapper) => {
		const label = wrapper.querySelector('label');
		const input = wrapper.querySelector('input');

		wrapper.addEventListener('click', function () {
			console.log('click');
			input.click(); // trigger the input click if you click the wrapper
		});

		input.addEventListener('change', function () {
			if (this.files.length > 0) {
				const fileName = this.files[0].name;
				console.log(fileName);
				label.textContent = fileName;
			} else {
				console.error('No file selected');
			}
		});
	});
}
document.addEventListener('DOMContentLoaded', handleFileChange);
// handleFileChange();


function moveSubmitButtonOnLoad() {
    const form = document.querySelector('.wpcf7-form');
    const submitButton = document.querySelector('.wpcf7-submit');

    // Check if the form and submit button exist
    if (form && submitButton) {
        const steps = form.querySelectorAll('fieldset'); // All the fieldsets (steps)

        if (steps.length > 0) {
            const lastStep = steps[steps.length - 1]; // Get the last fieldset

            console.log(lastStep);

            const backButton = lastStep.querySelector('.cf7mls_back'); // Find the back button in the last fieldset
            console.log(backButton);
            if (backButton) {
                // Move the submit button next to the back button if in the last step
                backButton.parentNode.appendChild(submitButton);
            } else {
                // Ensure the submit button is back in its original place if there's no back button
                form.querySelector('.cf7mls-btns').appendChild(submitButton);
            }
        }
    }
    // initializeButtonEffect();
}
document.addEventListener('DOMContentLoaded', moveSubmitButtonOnLoad);

// Define the function to handle form submission
function onCF7FormSuccess(event) {
    const formId = event.detail.contactFormId;
    if (formId === 1414) {
        console.log('Form ID 1414 submitted successfully!');
        console.log('Thank you for your submission!');
    }
}
// document.addEventListener('wpcf7submit', onCF7FormSuccess, false);

document.addEventListener('wpcf7submit', function(event) {
    const formId = event.detail.contactFormId;
    const status = event.detail.status;

    console.log(event.detail.contactFormId)
    console.log(event.detail.status)

    if ('1406' == formId && status === 'mail_sent') {
        console.log(formId);

        // Find the form by its data-wpcf7-id attribute
        const form = document.querySelector(`[data-wpcf7-id="${formId}"]`);
        if (form) {
            form.classList.add('form-submitted');
            console.log('Class "form-submitted" added to the form.');

            // Find .wpcf7-response-output
            const responseOutput = form.querySelector('.wpcf7-response-output');
            console.log(responseOutput);

            if (responseOutput) {

                responseOutput.style.opacity = '0';

                // Create a wrapper for the new content to avoid overwriting existing content
                const wrapper = document.createElement('div');
                wrapper.classList.add('custom-buttons');
                wrapper.innerHTML = `
                    <div class="c-button-group">
                        <a href="/get-in-touch" class="c-button-outline--white">
                            <span class="fill"></span>
                            <span class="text">Go to home</span>
                        </a>
                        <button type="button" aria-label="Reset form" class="c-button-solid--white interchangeable reset-form">
                            <span class="fill"></span>
                            <span class="text">Reset Form</span>
                        </button>
                    </div>`;

                // Append the wrapper only if it doesn't already exist
                if (!responseOutput.querySelector('.custom-buttons')) {
                    responseOutput.appendChild(wrapper);
                    console.log('HTML added to .wpcf7-response-output.');
                }

                // Add reset functionality to the reset button
                const resetButton = wrapper.querySelector('.reset-form');
                if (resetButton) {
                    resetButton.addEventListener('click', () => {
                        const formElement = form.querySelector('form');
                        if (formElement) {
                            formElement.reset();
                            console.log('Form has been reset.');
                        } else {
                            console.log('Form element not found for reset.');
                        }
                    });
                }

                setTimeout(() => {
                    responseOutput.style.opacity = '1';
                }, 500); // 100ms delay, adjust as needed

            } else {
                console.log('.wpcf7-response-output not found.');
            }
        } else {
            console.log('Form not found.');
        }
    }
}, false);

// All caps
function inputFieldCaps() {
    const postcodeFields = document.querySelectorAll('.postcode');

    postcodeFields.forEach(function(postcodeField) {
        postcodeField.addEventListener('input', function() {
            // Force the input to uppercase
            postcodeField.value = postcodeField.value.toUpperCase();
        });
    });
}
inputFieldCaps();
